<template>
  <!-- 相关问题 -->
  <div class="list-group list-group-flush">
    <a
      :href="`${qandaPage}/${list.qaQuestionId}`"
      target="_blank"
      class="list-group-item list-group-item-action"
      :key="`list-${list.qaQuestionId}`"
      v-for="list in mg_referalList"
    >
      <div class="media">
        <div class="media-body">
          <h5 class>{{ list.formatQATitle }}</h5>
          <small>
            <timeago :datetime="list.publishTime" locale="zh-CN"></timeago>
            · {{ list.nickname }}
          </small>
        </div>
        <div class="ml-3 text-center">
          <h5 class="mt-0">{{ list.numOfAnswer }}</h5>
          <small>回答</small>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import * as routes from '@/constants/routes';

export default {
  name: 'qa-referal-list',

  data() {
    return {
      qandaPage: routes.QA_QUESTION_PAGE,
    };
  },

  computed: {
    ...mapGetters('Mixins/QA', {
      mg_referalList: 'referalList',
    }),
  },
};
</script>
<style lang="scss" scoped></style>
